<template>
  <div class="autocomplete">
    <div class="search">
      <input
        ref="input"
        v-model="query"
        type="text"
        :placeholder="
          $store.getters['translations/getLabel']('SEARCH_PLACEHOLDER')
        "
      />
      <div v-if="query" ref="optionsList" class="options">
        <ul v-if="matches.length">
          <li v-for="(match, index) in matches" :key="index">
            <a @click.prevent="navigate(match)">
              <div class="lead">{{ match.name.toLowerCase() }}</div>
              <div class="subtitle">{{ match.type }} #{{ match.id }}</div>
            </a>
          </li>
        </ul>
        <ul v-else>
          <li v-label-key="'NO_RESULTS'">No results</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      selected: 0,
      query: '',
    };
  },
  computed: {
    matches() {
      if (this.query === '') {
        return [];
      }
      return this.items.filter(item => {
        const searchStr = `#${item.id} ${item.name} - ${item.type}`;
        return searchStr.toLowerCase().includes(this.query.toLowerCase());
      });
    },
  },
  methods: {
    navigate(data) {
      window.location.href = `#/${data.type}s/${data.id}`;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.autocomplete {
  position: relative;
  width: 100%;
}

@media (min-width: 992px) {
  .autocomplete {
    width: 300px;
  }
}

.input {
  height: 40px;
  border-radius: 3px;
  border: 2px solid lightgray;
  box-shadow: 0 0 10px #eceaea;
  font-size: 25px;
  padding-left: 10px;
  padding-top: 10px;
  cursor: text;
}
.placeholder {
  position: absolute;
  top: 11px;
  left: 11px;
  font-size: 25px;
  color: #d0d0d0;
  pointer-events: none;
}
.search {
  position: relative;
  background: #fff;
  text-align: center;
  z-index: 1;
}
.search input {
  width: 100%;
  height: 40px;
  font-size: 16px;
  border-radius: 3px;
  border: 1px solid lightgray;
  padding-left: 8px;
  outline: none;
}
.options {
  max-height: 200px;
  overflow-y: scroll;
  border: 1px solid #f6f6f6;
  position: absolute;
  width: 100%;
}
.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
  margin-bottom: 0;
}
.options ul li {
  border-bottom: 1px solid #f6f6f6;
  padding: 10px;
  cursor: pointer;
  background: #ffffff;
}

.options ul li:hover {
  background: #f8f9fa;
}
a {
  text-decoration: none;
  color: inherit;
}
.lead {
  font-size: 16px;
  text-transform: capitalize;
}
.subtitle {
  text-transform: capitalize;
  font-size: 14px;
  color: #727272;
}
</style>
